import React, { useState, useMemo } from 'react';
import { Styles } from './styles';
import { IPropertyPhoto } from '@stores/Property/types';
import { ImageModal } from '@components/ImageModal';

export interface ImageGalleryProps {
  photos: IPropertyPhoto[];
  label?: string;
}

/**
 * Componente de galeria de imagens somente leitura (sem controles de edição).
 * Ideal para telas de visualização.
 */
export const ImageGallery: React.FC<ImageGalleryProps> = ({
  photos,
  label = 'Imagens:'
}) => {
  const sortedPhotos = photos.slice().sort((a, b) => a.ordem - b.ordem);

  const [modalOpen, setModalOpen] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const imageUrls = useMemo(
    () =>
      sortedPhotos.map((foto) =>
        foto.file ? URL.createObjectURL(foto.file) : foto.uri
      ),
    [sortedPhotos]
  );

  const imageCaptions = useMemo(
    () => sortedPhotos.map((foto) => foto.legenda || ''),
    [sortedPhotos]
  );

  const handleImageClick = (index: number) => {
    setCurrentImageIndex(index);
    setModalOpen(true);
  };

  return (
    <Styles.ImageUploadSection>
      <Styles.Label>{label}</Styles.Label>

      {photos && photos.length > 0 && (
        <Styles.ImageGalleryGrid>
          {sortedPhotos.map((foto, index) => {
            const isCover = index === 0;
            return (
              <Styles.ImageCard
                key={foto.id ?? `${foto.uri}-${index}`}
                onClick={() => handleImageClick(index)}
                style={{ cursor: 'pointer' }}>
                <Styles.ImagePreview
                  src={foto.file ? URL.createObjectURL(foto.file) : foto.uri}
                  alt={foto.legenda || `Imagem ${index + 1}`}
                />
                <Styles.IndexCaption $isCover={isCover}>
                  {isCover ? `#${index + 1} - Capa` : `#${index + 1}`}
                </Styles.IndexCaption>
              </Styles.ImageCard>
            );
          })}
        </Styles.ImageGalleryGrid>
      )}

      <ImageModal
        images={imageUrls}
        currentIndex={currentImageIndex}
        isOpen={modalOpen}
        onClose={() => setModalOpen(false)}
        onNavigate={setCurrentImageIndex}
        captions={imageCaptions}
      />
    </Styles.ImageUploadSection>
  );
};

export default ImageGallery;
